import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Chrome sometimes logs this when ResizeObserver runs in the same frame as layout
// (backdrop-filter, cover images, third-party widgets). It is not actionable app logic.
const resizeObserverLoopErr =
  'ResizeObserver loop completed with undelivered notifications.';
window.addEventListener(
  'error',
  (e) => {
    if (e.message === resizeObserverLoopErr) {
      e.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
